import React, { Component } from 'react';
import styled from "react-emotion";
import Img from 'gatsby-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const StyledProfile = styled.div`
    padding: 0.5rem;
    position: relative;
    width: 25%;
    @media (max-width: ${props => props.theme.breakpoints.l}) {
        width: 25%;
    }
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 25%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
    }
`;

const Headshot = styled.div`
    position: relative;
    max-width: 400px;
    width: 100%;
    .photo-pair {
        position: relative;
        top: 0;
        left: 0;
    }
    .normal-photo {
        width: 100%;
        opacity: 1;
        visibility: visible;
        transition: opacity 800ms, visibility 800ms;
    }
    .fun-photo {
        width: 100%;
        transition: opacity 800ms, visibility 800ms;
        opacity: 0;
        visibility: hidden;
    }
    &:hover .normal-photo {
        opacity: 0;
        visibility: hidden;
    }
    &:hover .fun-photo {
        opacity: 1;
        visibility: visible;
    }
`;

const Caption = styled.div`
    min-width: 50%;
    max-width: 70%;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 1.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: stretch;

`;

const ProfileName = styled.p`
    width: 100%;
    bottom: 2.5rem;
    margin: 0;
    padding: 0.25em 0.4rem 0.5rem 0.4rem;
    color: ${props => props.theme.colors.white};
    background-color: rgba(28, 37, 43, 0.9);
    font-size: 12px;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        font-size: 11px;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        font-size: 18px;
    }
`;

const ProfileTitle = styled.p`
    position: absolute;
    top: 1.1rem;
    max-width: 90%;
    line-height: 100%;
    padding: 0.25rem 0.2rem 0.25rem 0.2rem;
    color: ${props => props.theme.colors.white};
    background-color: ${props => props.theme.colors.darkBlue};
    font-size: 8px;
    margin: 0;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        font-size: 9px;
        top: 1.1rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        font-size: 9px;
        top: 1.8rem;
    }
`;

const Biography = styled.p`
    max-height: 500px;
    margin-bottom: 0.5rem;
    font-size: 0.7rem;
    margin-top: 1rem;
    overflow: hidden;
`;
const ContactInformation = styled.div`
    position: absolute;
    background: ${props => props.theme.colors.darkBlue};
    border-radius: 50%;
    right: 2%;
    bottom: 0.5rem;
    width: 1.4rem;
    height: 1.4rem;
    line-height: 1.2rem;
    text-align: center;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
      width: 1.6rem;
      height: 1.6rem;
      line-height: 1.5rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      width: 1.8rem;
      height: 1.8rem;
      bottom: 0.7rem;
      line-height: 1.6rem;
    }
    a {

        color: ${props => props.theme.colors.white};

    }
    svg {
        width: 1rem !important;
        height: 1rem !important;
        @media (max-width: ${props => props.theme.breakpoints.m}) {
          width: 1.2rem !important;
          height: 1.2rem !important;
        }

    }
`;

class Profile extends Component {
    state = {}
    render() {
      const theme = { theme };
        const { info } = this.props;
        return (
            <StyledProfile>
                <Headshot>
                    <div className='photo-pair'>
                        <Img className='normal-photo' fluid={info.normal_photo.localFile.childImageSharp.fluid} style={{ position: 'relative', top: 0, left: 0, borderRadius: 3 }} />
                        <Img className='fun-photo' fluid={info.fun_photo.localFile.childImageSharp.fluid} style={{ position: 'absolute', top: 0, left: 0, borderRadius: 3 }} />
                    </div>
                    <Caption>
                        <ProfileName>{info.first_name.text} {info.last_name.text}</ProfileName>
                        <ProfileTitle>{info.position.text.toUpperCase()}</ProfileTitle>
                    </Caption>
                    <ContactInformation>
                        <a href={info.linkedin.url} rel="noreferrer" aria-label="Linkedin icon" target='_blank'><FontAwesomeIcon icon={faLinkedinIn} size='xs' /></a>
                    </ContactInformation>
                </Headshot>
                <Biography>{info.bio.text}</Biography>

            </StyledProfile>
        );
    }
}

export default Profile;
